exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".grid-header {\n  width: 12.5rem;\n  padding: 0.3125rem;\n  color: black;\n  border-top: solid 0.0625rem lightgray;\n  border-left: solid 0.0625rem lightgray;\n  border-right: solid 0.0625rem lightgray;\n  border-radius: 0.625rem 0.625rem 0 0;\n  text-align: center;\n  font-weight: 400; }\n\n.grid-container {\n  width: 12.5rem; }\n  .grid-container--fixed-viewport ag-grid-angular {\n    display: block;\n    width: 100%;\n    height: auto; }\n\n:host /deep/ .ag-menu2,\n:host /deep/ .driver-filter-fixed-popup {\n  z-index: 20100; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/driver-schedule/components/schedule/schedule.component.scss
// module id = 2015
// module chunks = 66